import { useRoutes } from "react-router-dom";
import MainRoute from "./routes/Main";
import ResultRoute from "./routes/Result";
import WelcomeRoute from "./routes/Welcome";
export default function Router() {
  const routes = useRoutes([WelcomeRoute, MainRoute, ResultRoute]);

  return routes;
}
